module.exports = new Map();